import Keycloak from 'keycloak-js';

// KeyCloak configuration
const keycloakConfig = {
  url: window.location.origin + '/auth',
  realm: 'tradeofflab',
  clientId: 'tradeofflab-frontend'
};

// Create KeyCloak instance
const keycloak = new Keycloak(keycloakConfig);

// Initialize KeyCloak
export const initKeycloak = async (onAuthSuccess, onAuthError) => {
  try {
    const authenticated = await keycloak.init({
      onLoad: 'check-sso', // Check for existing session on page load
      pkceMethod: 'S256',
      checkLoginIframe: false
    });

    if (authenticated) {
      console.log('User is authenticated');

      // Auto-refresh token
      keycloak.onTokenExpired = () => {
        keycloak.updateToken(30)
          .then(refreshed => {
            if (refreshed) {
              console.log('Token refreshed');
              if (onAuthSuccess) onAuthSuccess(keycloak.token);
            }
          })
          .catch(() => {
            console.error('Failed to refresh token');
            logout();
          });
      };
    } else {
      console.log('User is not authenticated');
    }

    // Always call success callback
    if (onAuthSuccess) onAuthSuccess(authenticated ? keycloak.token : null);

    return authenticated;
  } catch (error) {
    console.error('Failed to initialize KeyCloak', error);
    if (onAuthError) onAuthError(error);
    return false;
  }
};

// Login
export const login = () => {
  keycloak.login({
    redirectUri: window.location.origin + '/dashboard'
  });
};

// Logout
export const logout = () => {
  keycloak.logout({
    redirectUri: window.location.origin
  });
};

// Get token for API requests
export const getToken = () => {
  return keycloak.token;
};

// Get user info
export const getUserInfo = () => {
  if (!keycloak.authenticated) {
    return null;
  }

  return {
    username: keycloak.tokenParsed?.preferred_username,
    email: keycloak.tokenParsed?.email,
    id: keycloak.tokenParsed?.sub,
    roles: keycloak.tokenParsed?.realm_access?.roles || []
  };
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return keycloak.authenticated;
};

export default keycloak;
